<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        serviceTypeOptions: [],
        form: [
          { // 服务商账号
            label: '服务商账号',
            value: 'loginAcct',
            type: 'input',
            placeholder: '请输入服务商账号',
          },
          { // 服务商名称
            label: '服务商名称',
            value: 'serviceName',
            type: 'input',
            placeholder: '请输入服务商名称',
          },
          { // 联系人
            label: '联系人',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入联系人',
          },
          { // 服务商类型
            label: '服务商类型',
            value: 'serviceType',
            type: 'select',
            default: -1,
            placeholder: '请选择服务商类型',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData({
        ...searchBoxData,
        state: -1,
        status: -1,
        customerCode: '',
        companyName: '',
        customerName: '',
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'SYS_SERVICE_BUSI_TYPE',
    });
    this.searchBoxData.serviceTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
